import ICalculatorConfiguration from "../../models/ICalculatorConfiguration";
import { ICalculatorInput } from "../../models/ICalculatorInput";

export default function filterPaperTypes(
  pricingConfiguration: ICalculatorConfiguration,
  calculatorInput: ICalculatorInput,
) {
  const filteredPaperTypes =
    pricingConfiguration.pricingConfiguration.paperTypes.filter(
      (pt) =>
        pt.selectedPaperSizes.includes(calculatorInput.selectedPaperSize) &&
        (!calculatorInput.isDuplexSelected ||
          (pt.duplex && calculatorInput.isDuplexSelected)) &&
        pricingConfiguration.pricingConfiguration.pricingMatrix.filter(
          (entry) =>
            entry.selectedPrintingOption ===
              calculatorInput.selectedPrintingOption &&
            entry.paperTypes.includes(pt.guid) &&
            entry.selectedPaperSize === calculatorInput.selectedPaperSize &&
            entry.duplex === calculatorInput.isDuplexSelected,
        ).length > 0,
    );
  filteredPaperTypes.sort((a, b) => a.code.localeCompare(b.code));
  return filteredPaperTypes;
}
